import React, { FC } from "react";
import Box from "@mui/material/Box";
import { iModalHeaderProps } from "../../../../types/modalBoxType";

import "./modalHeader.css";

const ModalHeader: FC<iModalHeaderProps> = ({
    modalHeaderText,
    closeModal,
    hideCloseButton,
    sx,
    className
}) => {
    return (
        <>
            <Box className={`modalHeader ${className}`} sx={{ ...sx }}>
                <strong>{modalHeaderText}</strong>
                {!hideCloseButton && (
                    <button onClick={closeModal} type="button" className="img-hold">
                        <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M13 13L1 1"
                                stroke="#2C263F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M13 1L1 13"
                                stroke="#2C263F"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                )}
            </Box>
        </>
    );
};
export default ModalHeader;
